import { useEffect } from 'react';
import { theme } from './theme';

/**
 * Theme Provider
 * Applies theme colors as CSS variables
 * Wrap your app with this component
 */
export function ThemeProvider({ children }) {
  useEffect(() => {
    // Apply all theme colors as CSS variables
    const root = document.documentElement;
    
    Object.entries(theme).forEach(([key, value]) => {
      // Convert camelCase to kebab-case for CSS variables
      const cssKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
      root.style.setProperty(`--theme-${cssKey}`, value);
    });
  }, []);

  return <>{children}</>;
}
